var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "srchTop_wrap srch_mypage" }, [
          _c("article", { staticClass: "srch_detail" }, [
            _c("dl", { staticClass: "dl_select" }, [
              _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MENU")))]),
              _vm._v(" "),
              _c("dd", { attrs: { "data-input-type": "select" } }, [
                _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.BOARD_TYPE1,
                            expression: "BOARD_TYPE1"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: { id: "BOARD_TYPE1", name: "BOARD_TYPE1" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.BOARD_TYPE1 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.changeBoardType1($event)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.boardType1List, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.boardType1List.length > 0,
                                  expression: "boardType1List.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.BOARD_TYPE2,
                            expression: "BOARD_TYPE2"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: { id: "BOARD_TYPE2", name: "BOARD_TYPE2" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.BOARD_TYPE2 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.changeBoardType2($event)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.boardType2List, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.boardType2List.length > 0,
                                  expression: "boardType2List.length > 0"
                                }
                              ],
                              key: item.code,
                              attrs: {
                                "data-menu-grp-dtl-cd": item.menuGrpDtlCd
                              },
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "dl_select" }, [
              _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))]),
              _vm._v(" "),
              _c("dd", { attrs: { "data-input-type": "select" } }, [
                _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.PRD_CATEGORY_CD1,
                            expression: "PRD_CATEGORY_CD1"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: { id: "PRD_CATEGORY_CD1" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.PRD_CATEGORY_CD1 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.changeCategory1($event)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.categoryComboList1, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.categoryComboList1.length > 0,
                                  expression: "categoryComboList1.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.PRD_CATEGORY_CD2,
                            expression: "PRD_CATEGORY_CD2"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: { id: "PRD_CATEGORY_CD2" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.PRD_CATEGORY_CD2 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.changeCategory2($event)
                            }
                          ]
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.categoryComboList2, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.categoryComboList2.length > 0,
                                  expression: "categoryComboList2.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.PRD_CATEGORY_CD3,
                            expression: "PRD_CATEGORY_CD3"
                          }
                        ],
                        staticClass: "slt_white w100p",
                        attrs: { id: "PRD_CATEGORY_CD3" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.PRD_CATEGORY_CD3 = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.categoryComboList3, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.categoryComboList3.length > 0,
                                  expression: "categoryComboList3.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "dl_search" }, [
              _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.STATUS")))]),
              _vm._v(" "),
              _c("dd", { attrs: { "data-input-type": "select" } }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchStatus,
                        expression: "searchStatus"
                      }
                    ],
                    staticClass: "slt_white w100p",
                    attrs: { id: "searchStatus" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.searchStatus = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", selected: "" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.statusComboList, function(item) {
                      return _c(
                        "option",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.statusComboList.length > 0,
                              expression: "statusComboList.length > 0"
                            }
                          ],
                          key: item.code,
                          domProps: { value: item.code }
                        },
                        [_vm._v(_vm._s(item.codeName))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "dd",
                {
                  staticClass: "clearable",
                  attrs: { "data-input-type": "input" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.searchTitle,
                        expression: "searchTitle",
                        modifiers: { trim: true }
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100p",
                    attrs: {
                      id: "searchTitle",
                      name: "searchTitle",
                      type: "text",
                      maxlength: "200",
                      placeholder: _vm.$t(
                        "FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH"
                      )
                    },
                    domProps: { value: _vm.searchTitle },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.stopPropagation()
                        return _vm.handleSearch($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchTitle = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "clearable_clear" }, [
                    _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "srch_mypage_btn" }, [
              _c(
                "a",
                {
                  staticClass: "btn_srch",
                  attrs: { href: "javascript:" },
                  on: { click: _vm.handleSearch }
                },
                [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SEARCH")))]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "resize",
                rawName: "v-resize",
                value: _vm.setGridResizeColumn,
                expression: "setGridResizeColumn"
              }
            ],
            staticClass: "grid_wrap"
          },
          [
            _c("bug-report-grid", {
              ref: _vm.gridId,
              attrs: {
                gridId: _vm.gridId,
                columns: _vm.columns,
                data: _vm.gridData,
                options: _vm.options,
                pageOptions: _vm.pageOptions,
                isTotalCount: true,
                click: _vm.contentClick
              },
              on: { "grid-total-count": _vm.setTotalCount }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginate" },
              [
                _c("sdl-pagination", {
                  attrs: {
                    align: "center",
                    "current-page": _vm.currentPage,
                    "total-rows": _vm.totalCount,
                    "per-page": _vm.perPage
                  },
                  on: { change: _vm.movePage }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41047d81", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41047d81","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/myKnowledge/bugReport/BugReportList.vue
// module id = 9auZ
// module chunks = 0